<template>
    <svg
        class="svg svg--icon svg--search"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <title>Search</title>

        <g stroke-miterlimit="10">
            <line
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                x1="15.5"
                y1="15.5"
                x2="12.5"
                y2="12.5"
            />
            <circle
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="6.5"
                cy="6.5"
                r="6"
            />
        </g>
    </svg>
</template>
